let lockCount = 0;
let initialBodyOverflow = '';

export function lockBodyScroll () {
  if (lockCount === 0) {
    initialBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount++;
}

export function unlockBodyScroll () {
  if (lockCount === 0) return;

  lockCount--;

  if (lockCount === 0) {
    document.body.style.overflow = initialBodyOverflow;
    initialBodyOverflow = '';
  }
}

